export function addIfAvailable<T>(predicate: boolean, routes: T[]): T[] {
  return predicate ? routes : [];
}
